import { CartRequestPNRInt } from '@app/interfaces/cart.interface';
import { Passenger, Reservation } from '@app/models';
import { PAX_TYPE } from '@app/enums';
import { normalizeGender } from '@utils/functions/normalizeGender';
export class CartMapper {
  constructor() {}

  static cartPnrUpdate(cartId: string, request: CartRequestPNRInt): CartRequestPNRInt {
    if (request?._warnings._collection != null) {
      if (request._warnings._collection.length > 0) {
        if (request._warnings._collection[0].actionable != 'CONTINUE') {
          return request;
        }
      }
    }

    return request as CartRequestPNRInt;
  }

  static mapPasengerToRequest(reservation: Reservation, passengers: Passenger[]) {
    const cartId = reservation?.apiCart?.cartId;
    const selected = reservation?.passengers
      .filter((p) => p?.paxType != PAX_TYPE.INFANT && p?.checkinSelected)
      .map((passenger) => {
        const isSelectedToCheckin = passengers.find((p) => p?.id == passenger?.id)?.checkinSelected;
        return {
          id: passenger.id,
          isSelectedToCheckin,
          _meta: {
            class: 'BookedTraveler',
          },
        };
      });

    return {
      cartId: cartId,
      travelerInfo: {
        _collection: selected,
        _meta: {
          class: 'BookedTravelerCollection',
        },
      },
      _meta: {
        class: 'CartPNRUpdate',
      },
    };
  }

  static mapPasengerToRequestFrequentFly(passenger: Passenger) {
    const selected = {
      id: passenger.id,
      isSelectedToCheckin: passenger.checkinSelected,
      frequentFlyerNumber: passenger.frequentFlyerNumber,
      frequentFlyerProgram: passenger.frequentFlyerProgram,
      ancillaries: null,
      segmentChoices: null,
      _meta: {
        class: 'BookedTraveler',
      },
    };

    return {
      cartId: null,
      travelerInfo: {
        _collection: [selected],
        _meta: {
          class: 'BookedTravelerCollection',
        },
      },
      _meta: {
        class: 'CartPNRUpdate',
      },
    };
  }

  static mapPasengerToRequestGender(passengers: Passenger[]) {
    const selected = passengers.map((p) => {
      return {
        id: p.id,
        isSelectedToCheckin: p.checkinSelected,
        gender: normalizeGender(p.gender),
        _meta: {
          class: 'BookedTraveler',
        },
      };
    });

    return {
      cartId: null,
      travelerInfo: {
        _collection: selected,
        _meta: {
          class: 'BookedTravelerCollection',
        },
      },
      _meta: {
        class: 'CartPNRUpdate',
      },
    };
  }
}
